import { render } from "./DataSwitch.vue?vue&type=template&id=3575ed9a&scoped=true"
import script from "./DataSwitch.vue?vue&type=script&lang=js"
export * from "./DataSwitch.vue?vue&type=script&lang=js"

import "./DataSwitch.vue?vue&type=style&index=0&id=3575ed9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3575ed9a"]])

export default __exports__